/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  // Check if printer has been set or not
  if (localStorage.getItem("printer") == "" || localStorage.getItem("printer") == undefined || localStorage.getItem("printer") == null) localStorage.setItem("printer", 0); // Check if printer has been set or not

  if (localStorage.getItem("paperSize") == "" || localStorage.getItem("paperSize") == undefined || localStorage.getItem("paperSize") == null) localStorage.setItem("paperSize", 0);

  var printMyText = function printMyText() {
    window.DatecsPrinter.printText(window.print_text, 'ISO-8859-1');

    if (window.service == "kiosk") {
      window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}", 'ISO-8859-1');
    }

    if (window.print_barcode != "" && window.print_barcode != undefined) {
      printMyBarcode(window.print_barcode);
    } else {
      window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}{CENTER}", 'ISO-8859-1');
      window.DatecsPrinter.writeHex('1B69');
      if (window.print_pay != "") window.DatecsPrinter.getStatus(); //THIS TO OPEN THE DRAWER

      $f7.views.current.router.back(window.print_page);
    }
  };

  var printMyImage = function printMyImage() {
    var image = new Image();
    image.src = 'static/images/gd.jpg';

    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.height = 100;
      canvas.width = 100;
      var context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

      window.DatecsPrinter.printImage(imageData, //base64
      canvas.width, canvas.height, 1, function () {
        printMyQR();
      });
    };
  };

  var printMyQR = function printMyQR() {
    var qrcodejs = new QRCode("qrcode", {
      text: window.print_qr,
      width: 150,
      height: 150,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H
    });

    var imageData = qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg").replace(/^data:image\/(png|jpg|jpeg);base64,/, "");

    console.log(qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg"));
    window.DatecsPrinter.printImage(imageData, //base64
    150, 150, 1, function () {
      printMyText();
    });
  };

  var DisplayMyQR = function DisplayMyQR() {
    if (window.print_qr != "" && window.print_qr != undefined) var qrcodejs = new QRCode("qrcode", {
      text: window.print_qr,
      width: 150,
      height: 150,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H
    });
  };

  var printMyBarcode = function printMyBarcode(text) {
    var canvas = document.createElement("canvas");
    canvas.height = 400;
    canvas.width = 300;
    JsBarcode(canvas, text, {
      format: "CODE128",
      width: 2
    });
    var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

    window.DatecsPrinter.printImage(imageData, //base64
    canvas.width, canvas.height, 1, function () {
      if (window.print_total_after_barcode != "" && window.print_total_after_barcode != undefined) {
        window.DatecsPrinter.printText(window.print_total_after_barcode, 'ISO-8859-1');
        window.print_total_after_barcode = "";
      }

      if (localStorage.getItem("printerName") == "Printer001") {
        window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}", 'ISO-8859-1');
        window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}", 'ISO-8859-1');
      }

      window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{BR}{CENTER}", 'ISO-8859-1');
      window.DatecsPrinter.writeHex('1B69');
      if (window.print_pay != "") window.DatecsPrinter.getStatus(); //THIS TO OPEN THE DRAWER 

      $f7.views.current.router.back(window.print_page);
    });
  };

  var printPurchase = function printPurchase() {
    if (window.print_pay == "true") {
      $f7.request({
        method: 'get',
        url: window.waypoint + window.print_pay_url,
        data: {
          lang: window.lang,
          reqId: window.uuid,
          latitude: window.lat,
          longitude: window.lot,
          orderId: window.print_orderId,
          free58: window.paper_free58,
          free80: window.paper_free80,
          paper58: window.paper_58,
          paper80: window.paper_80
        },
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
        },
        success: function success(data) {
          console.log(data);
          var data = JSON.parse(data);

          if (data.ALERT != undefined && data.ALERT != "") {
            $f7.dialog.alert(data.ALERT);
          }

          if (data.status == "1") {
            console.log("HIT PAY");

            if (!window.DatecsPrinter) {
              alert("DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'");
            } else {
              window.bluetooth = localStorage.getItem("printer");
              if (window.bluetooth == null || window.bluetooth == undefined) window.bluetooth = 0;
              window.DatecsPrinter.listBluetoothDevices(function (devices) {
                localStorage.setItem("printerName", devices[window.bluetooth].name);
                window.DatecsPrinter.connect(devices[window.bluetooth].address, function () {
                  if (window.print_qr != "") {
                    printMyQR();
                  } else {
                    printMyText();
                  }
                }, function () {
                  $f7.views.main.router.navigate(window.print_page);
                  alert(JSON.stringify(error));
                });
              }, function (error) {
                $f7.views.main.router.navigate(window.print_page);
                alert(JSON.stringify(error));
              });
            }
          } else {
            $f7.dialog.alert(data.errMsg, "Error");
          }
        }
      });
    } else {
      if (!window.DatecsPrinter) {
        alert("DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'");
      } else {
        window.bluetooth = localStorage.getItem("printer");
        if (window.bluetooth == null || window.bluetooth == undefined) window.bluetooth = 0;
        window.DatecsPrinter.listBluetoothDevices(function (devices) {
          localStorage.setItem("printerName", devices[window.bluetooth].name);
          window.DatecsPrinter.connect(devices[window.bluetooth].address, function () {
            if (window.print_qr != "") {
              printMyQR();
            } else {
              printMyText();
            }
          }, function () {
            $f7.views.main.router.navigate(window.print_page);
            alert(JSON.stringify(error));
          });
        }, function (error) {
          $f7.views.main.router.navigate(window.print_page);
          alert(JSON.stringify(error));
        });
      }
    }
  };

  $on('pageAfterIn', function () {
    $f7.toolbar.hide(".toolbar-app");
  });
  $on('pageAfterOut', function () {
    $f7.toolbar.show(".toolbar-app");
  });
  $on('pageInit', function () {
    if (window.print_qr == "" || window.print_qr == undefined) {
      $(".qr-frame").hide();
    }

    if (window.print_pay == "true") {
      $('.print-pay').html("PAID");
    } else {
      $('.print-pay').html("PRINT COPY");
    }

    if (window.print_hide_button == "true") {
      $('.button-print').hide();
      $('.button-cancel').hide();
      $('.button-done').show();
      window.print_hide_button = "";
    } else {
      $('.button-print').show();
      $('.button-cancel').show();
      $('.button-done').hide();
    }

    printPreview();
    DisplayMyQR();
  });

  var printCancel = function printCancel() {
    $f7.views.current.router.back(window.print_page);
  };

  var printPreview = function printPreview() {
    $('.printtext').html(window.print_detail);
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="kiosk_receipt">

  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title title-receipt">
        <span class='en'>Receipt</span>
        <span class='cn'>收据确认</span>
        <span class='tl'>Resibu konfirmasaun</span>
      </div>
    </div>
  </div>

  <div class="fab fab-extended fab-right-bottom color-teal button-print">
    <a href="#" @click=${printPurchase}>
      <i class="icon f7-icons">printer</i>
      <div class="fab-text print-pay" style="font-size: 18px;">Print</div>
    </a>
  </div>

  <div class="fab fab-extended fab-left-bottom button-cancel" style="color:var(--f7-theme-color)">
    <a href="#" @click=${printCancel}>
      <i class="icon f7-icons">multiply</i>
      <div class="fab-text" style="font-size: 18px;">
        <span class='en'>Back</span>
        <span class='cn'>Back</span>
        <span class='tl'>Back</span>
      </div>
    </a>
  </div>
  
  <div class="page-content">
    <!-- <div class="block-title block-title-large">Receipt</div> -->
    <div class="printtext">

    </div>



 






    <div class="block" >
      <center>
        <table class="qr-frame" style="background-color: white;" cellpadding="10px">
          <td><div id="qrcode"></div></td>
        </table>
      </center>

      <br/>
      <br/>
      <a href="#" class="button button-fill button-round link back button-done">
        <div class="fab-text" style="font-size: 18px;">Done</div>
      </a>

    </div>

    <div class="block" style="display: none;">
      <div style="text-align: center;">

        <img id="barcode"/>

        <img src='static/images/printer.png' width="400px"/>
        <br/>
        
        <p>
            <span class='en'>Printing your receipt...</span>
            <span class='cn'>打印收据...</span>
            <span class='tl'>Imprime ita-boot Nia resibu.</span>
        </p>
      </div>
      
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '448c3d41f8';
export default framework7Component;